import React, { useState } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import './styles/financialReport.css';
import FinancialReport from './components/FinancialReport';
import { ActionProvider } from './contexts/ActionContext';
import Header from './components/Header';

// Default tenant ID now set to recv150yB0U8xsn0o as requested
const DEFAULT_TENANT_ID = 'recv150yB0U8xsn0o';

function App() {
  return (
    <ActionProvider>
      <div className="App">
        <Header />
        
        <Routes>
          {/* Redirect from root to /financial-report with default ID */}
          <Route path="/" element={<Navigate to={`/financial-report/${DEFAULT_TENANT_ID}`} replace />} />
          
          {/* Redirect from /financial-report to /financial-report/DEFAULT_TENANT_ID */}
          <Route path="/financial-report" element={<Navigate to={`/financial-report/${DEFAULT_TENANT_ID}`} replace />} />
          
          {/* Financial report with tenant ID */}
          <Route path="/financial-report/:tenantId" element={<FinancialReportPage />} />
        </Routes>
      </div>
    </ActionProvider>
  );
}

// Financial Report Page Component
function FinancialReportPage() {
  const [linkCopied, setLinkCopied] = useState(false);
  // Extract tenant ID from URL
  const navigate = useNavigate();
  const pathSegments = window.location.pathname.split('/');
  const tenantIdFromPath = pathSegments[pathSegments.length - 1] || DEFAULT_TENANT_ID;
  
  const [tenantId, setTenantId] = useState(tenantIdFromPath);
  const [customTenantId, setCustomTenantId] = useState('');

  const handleTenantChange = (e) => {
    const newTenantId = e.target.value;
    setTenantId(newTenantId);
    navigate(`/financial-report/${newTenantId}`);
  };

  const handleCustomTenantSubmit = (e) => {
    e.preventDefault();
    if (customTenantId.trim()) {
      const newTenantId = customTenantId.trim();
      setTenantId(newTenantId);
      navigate(`/financial-report/${newTenantId}`);
    }
  };

  // Function to generate a shareable link
  const getShareableLink = () => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/financial-report/${tenantId}`;
  };

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(getShareableLink())
      .then(() => {
        setLinkCopied(true);
        setTimeout(() => {
          setLinkCopied(false);
        }, 3000);
      })
      .catch(err => {
        console.error('Erreur lors de la copie du lien:', err);
      });
  };

  return (
    <>
    
      <FinancialReport tenantId={tenantId} />
    </>
  );
}

export default App;
